export default __webpack_public_path__ + "static/media/gallery2.f293eb42.png";